var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedCircleCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33.3349953px",
    height: "33.334651px",
    viewBox: "0 0 33.3349953 33.334651",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "circle-check 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle-check",
    transform: "translate(-3.3333, -3.3335)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 40 0 40 40 0 40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3333333,5.56666667 C35.2790005,9.57701313 38.3833736,17.965631 35.7216667,25.5313753 C33.0599598,33.0971196 25.3870871,37.6941912 17.4604144,36.472295 C9.53374163,35.2503988 3.60143473,28.5560895 3.34166667,20.54 L3.33333333,20 L3.34166667,19.46 C3.53153235,13.6049706 6.78136957,8.27950602 11.901487,5.43313728 C17.0216045,2.58676854 23.2601496,2.63746456 28.3333333,5.56666667 L28.3333333,5.56666667 Z M26.1783333,15.4883333 C25.5845524,14.8946082 24.6418088,14.8353296 23.9783333,15.35 L23.8216667,15.4883333 L18.3333333,20.975 L16.1783333,18.8216667 L16.0216667,18.6833333 C15.3581629,18.1690385 14.4157103,18.2284981 13.8221042,18.8221042 C13.2284981,19.4157103 13.1690385,20.3581629 13.6833333,21.0216667 L13.8216667,21.1783333 L17.155,24.5116667 L17.3116667,24.65 C17.9129061,25.1164824 18.7537605,25.1164824 19.355,24.65 L19.5116667,24.5116667 L26.1783333,17.845 L26.3166667,17.6883333 C26.831337,17.0248579 26.7720585,16.0821142 26.1783333,15.4883333 L26.1783333,15.4883333 Z",
    id: "Shape",
    fill: "#C8453A",
    fillRule: "nonzero"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCircleCheck);
export default __webpack_public_path__ + "static/media/red-circle-check.92f46e0e77800536ef57627df2d24cd7.svg";
export { ForwardRef as ReactComponent };